/**
 * Preço de entrada do plano (espelho do catálogo em db/seeds.rb). Um lugar só,
 * pra copy que aparece antes de /api/plans carregar. A vitrine em si lê da API.
 */
export const PLAN_FROM_PRICE = "R$ 19,90/mês"
/** Detalhe ao lado do CTA de objetivo — nunca a manchete. */
export const PLAN_FROM_TEXT = `A partir de ${PLAN_FROM_PRICE}, pagamento único · sem renovação automática`
/** Preço inteiro, para o pitch do tratamento — os dois planos numa frase só. */
export const PLAN_PRICE_LINE =
  "R$ 19,90 por 30 dias — ou R$ 97 pelo ano inteiro. Pagamento único, sem renovação automática, 7 dias de garantia incondicional."
